import { IconButton, Modal, Text } from '@perch-labs/shrike';
import camelCase from 'lodash/camelCase';
import { useState } from 'react';
import { Link } from '~/components/link';
import { ContractLinkScreen, EventName, Logger, Status } from '~/utils/logger';
import { HeaderTitle, StyledHeader } from './consent-link.style';

export interface ConsentLinkProps {
  labelText: string;
  headerText: string;
  bodyContent: string;
  /** Renders a Download button inside the consent modal when provided. Hidden by default. */
  downloadUrl?: string;
  linkcolor?: 'primary' | 'secondary';
  screen?: ContractLinkScreen;
}

export const ConsentLink = ({
  labelText,
  headerText,
  bodyContent,
  downloadUrl,
  linkcolor,
  screen = EventName.UserScreen,
}: ConsentLinkProps) => {
  const [showConsentModal, setShowConsentModal] = useState(false);

  return (
    <>
      {showConsentModal ? (
        <Modal aria-label={headerText} onDismiss={() => setShowConsentModal(false)} size="large">
          <StyledHeader>
            <HeaderTitle tag="h2" textStyle="heading700">
              {headerText}
            </HeaderTitle>
            {!!downloadUrl && (
              <IconButton
                aria-label="Download consent document"
                icon="DownloadIcon"
                margin={{ left: '16px' }}
                onClick={() => window.open(downloadUrl, '_blank')}
              />
            )}
            <IconButton
              aria-label="Close button"
              icon="UIClose"
              margin={{ left: '16px' }}
              onClick={() => setShowConsentModal(false)}
            />
          </StyledHeader>
          <div style={{ flexGrow: 1, padding: '24px 32px' }}>
            <Text>{bodyContent}</Text>
          </div>
        </Modal>
      ) : null}
      <Link
        color={linkcolor || 'secondary'}
        textAlign="left"
        name={headerText}
        onClick={() => {
          const clicked = { [`${camelCase(headerText)}Clicked`]: true };
          // Opening the notes modal is not legal completion. A status here would
          // stamp legalScreen complete, including duration, before submit. (SUBEXP-3193)
          Logger.logEvent(
            screen === EventName.LegalScreen ? clicked : { status: Status.Completed, ...clicked },
            screen,
          );
          setShowConsentModal(true);
        }}
        openInNewTab={false}
      >
        {labelText}
      </Link>
    </>
  );
};
